'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'user-astronaut';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f4fb';
var svgPathData = ['M96 464c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32l0 48-56 0 0-24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24-48 0 0-24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24-56 0 0-48zm16-288c0-53 43-96 96-96l32 0c53 0 96 43 96 96s-43 96-96 96l-32 0c-53 0-96-43-96-96zm24 0c0 3.4 2.2 6.4 5.5 7.3l21.2 6 6 21.2c.9 3.3 3.9 5.5 7.3 5.5s6.4-2.2 7.3-5.5l6-21.2 21.2-6c3.3-.9 5.5-3.9 5.5-7.3s-2.2-6.4-5.5-7.3l-21.2-6-6-21.2c-.9-3.3-3.9-5.5-7.3-5.5s-6.4 2.2-7.3 5.5l-6 21.2-21.2 6c-3.3 .9-5.5 3.9-5.5 7.3z', 'M388 224c-25.6 65.6-89.4 112-164 112S85.6 289.6 60 224l-4 0c-13.3 0-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24l4 0C85.6 30.4 149.4-16 224-16S362.4 30.4 388 96l4 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24l-4 0zM112 176c0 53 43 96 96 96l32 0c53 0 96-43 96-96s-43-96-96-96l-32 0c-53 0-96 43-96 96zM95.6 343.6C132 369.1 176.2 384 224 384s92-14.9 128.4-40.4c47.7 28.8 79.6 81.2 79.6 141 0 15.1-12.3 27.4-27.4 27.4l-52.6 0 0-48c0-17.7-14.3-32-32-32l-192 0c-17.7 0-32 14.3-32 32l0 48-52.6 0c-15.1 0-27.4-12.3-27.4-27.4 0-59.8 31.9-112.2 79.6-141zM152 488c0-13.3 10.7-24 24-24s24 10.7 24 24l0 24-48 0 0-24zm120-24c13.3 0 24 10.7 24 24l0 24-48 0 0-24c0-13.3 10.7-24 24-24z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUserAstronaut = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;